export var RewardTypeEnum;
(function (RewardTypeEnum) {
    RewardTypeEnum["ONE_TIME"] = "ONE_TIME";
    RewardTypeEnum["RECURRING"] = "RECURRING";
})(RewardTypeEnum || (RewardTypeEnum = {}));
//# sourceMappingURL=reward-type.enum.js.map